// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["corejsVendor-node_modules_core-js_stable_index_js","reactVendor-node_modules_react-dom_client_js-node_modules_react-intl_lib_index_js-node_module-cdfdd3","vendors-node_modules_capacitor-community_file-opener_dist_esm_index_js-node_modules_capacitor-080dd7"], () => (__webpack_require__("./src/home/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
